export const createDraftRecipient = (email: string, name?: string): TDraftRecipient => ({ email, name })

export const getRecipientsEmails = (recipients: { email: string }[]): string[] =>
  recipients.map(recipient => recipient.email)
